export default __webpack_public_path__ + "static/media/Zayavki.fae53705.svg";